import { render, staticRenderFns } from "./afterSalesList.vue?vue&type=template&id=a73e745c&"
import script from "./afterSalesList.vue?vue&type=script&lang=js&"
export * from "./afterSalesList.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a73e745c')) {
      api.createRecord('a73e745c', component.options)
    } else {
      api.reload('a73e745c', component.options)
    }
    module.hot.accept("./afterSalesList.vue?vue&type=template&id=a73e745c&", function () {
      api.rerender('a73e745c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/afterSalesList.vue"
export default component.exports